import React, {useState} from 'react';
import { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import common from '../../services/commonService';
import {Box, Switch, Slider, Select, MenuItem, Checkbox, FormControlLabel, Tooltip, Button, FormControl, FormLabel,RadioGroup, Radio } from '@material-ui/core'
import { settings } from 'cluster';

export function TagSelector(props: any) {

    // eslint-disable-next-line
  const [value, setValue] = useState(0); 

  const handleChanges = (key: string, value: any) => {
    try {
      switch(key) {

        case 'PlatesTagType':
          switch(value as number) {
            case 0:
              if ( common.plates.settings.tagOcr)
                common.plates.newTagType = 'Ocr';
              break;

            case 1:
              if ( common.plates.settings.tagVehicle)
              common.plates.newTagType = 'Vehicle';
              break;

            case 2:
              if ( common.plates.settings.tagInside)
              common.plates.newTagType = 'Inside';
              break;

            case 3:
              if (common.plates.settings.tagLights)
                common.plates.newTagType = 'Lights';
              break;

            case 4:
              if (common.plates.settings.tagHazard)
              common.plates.newTagType = 'Hazard';
            break;

            case 5:
              if (common.plates.settings.tagChars)
              common.plates.newTagType = 'Chars';
              break;

              case 6:
                if (common.plates.settings.tagReflective)
                common.plates.newTagType = 'Reflective';
                break;
  
              
  
          }
          setValue(v => v + 1);
          common.notify('PlatesTagTypeChanged2')
          break;

        case 'TagType':
        common.plates.newTagType = value;
        setValue(v => v + 1);
        common.notify('PlatesTagTypeChanged2')
        break;

        case 'PlatesTagTypeChanged':
          setValue(v => v + 1);
          break;
      }

    } catch (ex) {
      console.error('failed ')
    }
  }

  React.useEffect(() => {
    const subscription = common.notifier$.subscribe (msg => {
      handleChanges(msg.name as string, msg.data);
    });
    return (() => {
      subscription.unsubscribe();
    });
  }, []);

  const classes = useStyles();
  const isEnabled = (key:string) => {
    try {
      // todo - move to common.
      const settings = common.plates.settings;
      switch(key) {
        case "Ocr": return settings.tagOcr;
        case "Vehicle": return settings.tagVehicle;
        case 'Inside': return settings.tagInside;
        case "Lights":return settings.tagLights;
        case 'Hazard': return settings.tagHazard;
        case 'Chars': return settings.tagChars;
        case 'Reflective': return settings.tagReflective;
          
      }
      return false;

    } catch (ex) {
      console.error('failed on isDsiabled:', ex);
      return false;
    }
  }


  return <Box display="flex" flexDirection="row" flex="1" style={{background:'silver', paddingTop:'6px', paddingLeft:'6px'}} >

    <b>&nbsp;Tag:&nbsp;</b>
    <FormControl component="fieldset">
      <RadioGroup row aria-label="gender" name="tagType" value={common.plates.newTagType} onChange={(evt:any) => handleChanges("TagType", evt.target.value)}>
      
      {isEnabled("Ocr")  && <FormControlLabel  value="Ocr" control={<Radio />} label="OCR" style={{height:'22px'}} />}
      {isEnabled('Chars') &&  <FormControlLabel  value="Chars" control={<Radio />} label="Chars" style={{height:'22px'}} />}
      {isEnabled('Vehicle') &&   <FormControlLabel value="Vehicle" control={<Radio />} label="Vehicle" style={{height:'22px'}} />}
      {isEnabled('Inside') &&  <FormControlLabel value="Inside" control={<Radio />} label="Inside" style={{height:'22px'}} />}
      {isEnabled('Lights') &&  <FormControlLabel value="Lights" control={<Radio />} label="Light" style={{height:'22px'}} />}
      {isEnabled('Hazard') &&  <FormControlLabel value="Hazard" control={<Radio />} label="Hazard" style={{height:'22px'}} />}
      {isEnabled('Reflective') && <FormControlLabel  value="Reflective" control={<Radio />} label="Reflective" style={{height:'22px'}} />}
   
        </RadioGroup>
    </FormControl>
  </Box>
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    margin: 2,
    fontSize: 9,
    color: 'white',
    backgroundColor: 'black',
    '&:hover': {
      backgroundColor: 'gray',
      color: 'black',
  },
  },
}));
